import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { SEARCH_FIELD_BOX_PADDING } from '../../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programCollectioWrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  programCollectionTitle: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
}));
